module.exports = __webpack_public_path__ + "static/media/statement.863c1d11.svg";